'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Track = function (_React$Component) {
    _inherits(Track, _React$Component);

    function Track() {
        _classCallCheck(this, Track);

        /**
         * @param {SyntheticEvent} event - User event
         */
        var _this = _possibleConstructorReturn(this, (Track.__proto__ || Object.getPrototypeOf(Track)).apply(this, arguments));

        _this.handleMouseDown = function (event) {
            var onTrackMouseDown = _this.props.onTrackMouseDown;

            var clientX = event.touches ? event.touches[0].clientX : event.clientX;
            var trackClientRect = _this.getClientRect();
            var position = {
                x: clientX - trackClientRect.left,
                y: 0
            };
            onTrackMouseDown(event, position);
        };
        /**
         * @param {SyntheticEvent} event - User event
         */
        _this.handleTouchStart = function (event) {
            _this.handleMouseDown(event);
        };
        return _this;
    }

    _createClass(Track, [{
        key: 'getClientRect',
        value: function getClientRect() {
            return this.node.getBoundingClientRect();
        }
        /**
         * @return {Object} CSS styles
         */

    }, {
        key: 'getActiveTrackStyle',
        value: function getActiveTrackStyle() {
            var percentages = this.props.percentages;

            var width = (percentages.max - percentages.min) * 100 + '%';
            var left = percentages.min * 100 + '%';
            return { left: left, width: width };
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var activeTrackStyle = this.getActiveTrackStyle();
            var _props = this.props,
                className = _props.className,
                children = _props.children;

            return _react2.default.createElement("div", { className: className.track, onMouseDown: this.handleMouseDown, onTouchStart: this.handleTouchStart, ref: function ref(node) {
                    _this2.node = node;
                }, role: "button" }, _react2.default.createElement("div", { style: activeTrackStyle, className: className.activeTrack }), children);
        }
    }]);

    return Track;
}(_react2.default.Component);

exports.default = Track;

Track.propTypes = {
    children: _propTypes2.default.node.isRequired,
    className: _propTypes2.default.objectOf(_propTypes2.default.string).isRequired,
    onTrackMouseDown: _propTypes2.default.func.isRequired,
    percentages: _propTypes2.default.objectOf(_propTypes2.default.number).isRequired
};
//# sourceMappingURL=Track.js.map